import React from 'react';
import styled from 'styled-components';

// import {BrowserRouter, Route, Switch} from 'react-router-dom'
// import Home from './pages/home/home';
// import UserProfile from './pages/user-profile/user-profile';
// import Repos from './pages/repos/repos';
// import Followers from './pages/followers/followers';
// import Following from './pages/following/following';
// import TabNavigation from './components/tab-navigation/tab-navigation';
// import { UserProvider } from './UserContext';
// import ProtectedRoute from './ProtectedRoute';
// import GlobalStyle from './globalStyles';
import Routes from './routes';

export function App() {
  return (
    <Routes />
  );
}

export default App;
